import React from "react"
import Col from "react-bootstrap/Col"
import styled from "styled-components"
import GatsbyImage from "gatsby-image"
import { marker } from "../../../../assets/index"
import { IProject } from "../../../../types/project"

const Line = styled.div`
  display: flex;
  align-items: baseline;
  margin: 10px 0;
`

const Shortname = styled.div`
  text-transform: uppercase;
  font-size: var(--font-size-md);
  padding: 0 6px;
  background-color: var(--color-dark);
  color: var(--color-light);
`

const Name = styled.h3`
  margin: 0 0 0 16px;
  padding: 5px 0px 0px 0px;
  font-size: var(--font-size-md);
`
const Roles = styled.p`
  font-size: var(--font-size-xs);
`

const Place = styled.div`
  display: flex;
  align-items: center;
  font-size: var(--font-size-md);
  font-family: var(--font-secondary);

  img {
    width: 8px;
    transform: translateY(-2px);
  }

  span {
    margin: 0 0 0 5px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`

const Image = styled(GatsbyImage)``

const SelectableCard = styled(Col)`
  &.popin-open {
    opacity: 0.5;
  }

  &.active {
    opacity: 1;
  }

  &:hover {
    opacity: 0.8;
  }
`

const CardWrapper = styled(SelectableCard)`
  margin-bottom: 50px;
  cursor: pointer;
`

interface IProps {
  item: IProject
  isFocus: boolean
  selectProject: (item: IProject) => void
  selectedProject: IProject | undefined
  popinOpen: boolean
}

const ViewCard = ({
  item,
  isFocus,
  selectProject,
  selectedProject,
  popinOpen,
}: IProps): JSX.Element => {
  return (
    <CardWrapper
      sm={12}
      md={6}
      lg={4}
      xl={3}
      onClick={() => selectProject(item)}
      className={`${
        item.name === selectedProject?.name ? "active" : ""
      } ${popinOpen ? "popin-open" : ""}`}
    >
      {item?.cover?.fluid && (
        <Image
          fluid={{
            ...item.cover.fluid,
            aspectRatio: 16 / 9,
          }}
          className={isFocus ? "focus" : ""}
          alt={item.name}
        />
      )}
      <Line>
        <Shortname>{item.shortname}</Shortname>
        <Name>{item.name}</Name>
      </Line>
      <Place>
        <img src={marker} alt="Place" />
        <span>
          {item.region}, {item.city} ({item.department})
        </span>
      </Place>
      <Roles>{item.role?.join(", ")}</Roles>
    </CardWrapper>
  )
}

export default ViewCard
